import { CurrentAddress, GeoLocation } from '../appTypings';
import { fetchGeoLocation } from '../../service/locationApi';
import useSWRImmutable from 'swr/immutable';

export const geoLocationDefault: CurrentAddress = {
  geoLocation: GeoLocation.Finland,
};

async function fetcher(): Promise<CurrentAddress> {
  return fetchGeoLocation();
}

export function useGeolocation() {
  const { data } = useSWRImmutable('geolocation', fetcher);
  if (!data) return { data: geoLocationDefault };
  return { data };
}
